/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RequestItemVisibility = {
    Participant: 'participant',
    StaffOnly: 'staff_only',
} as const;
export type RequestItemVisibility = typeof RequestItemVisibility[keyof typeof RequestItemVisibility];


export function instanceOfRequestItemVisibility(value: any): boolean {
    for (const key in RequestItemVisibility) {
        if (Object.prototype.hasOwnProperty.call(RequestItemVisibility, key)) {
            if (RequestItemVisibility[key as keyof typeof RequestItemVisibility] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RequestItemVisibilityFromJSON(json: any): RequestItemVisibility {
    return RequestItemVisibilityFromJSONTyped(json, false);
}

export function RequestItemVisibilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestItemVisibility {
    return json as RequestItemVisibility;
}

export function RequestItemVisibilityToJSON(value?: RequestItemVisibility | null): any {
    return value as any;
}

export function RequestItemVisibilityToJSONTyped(value: any, ignoreDiscriminator: boolean): RequestItemVisibility {
    return value as RequestItemVisibility;
}

